import { config } from "../env";
import {
  Delete,
  get,
  patch,
  post,
  postFileUpload,
} from "./helpers/http-handler";

// --------------------------------  Configuration   ------------------------------------ //

export const getDashboardSelfComplianceIC = (queryRequest: string) =>
  get(
    `${config.API_URL}/internal-compliance-task/view/dashboard?${queryRequest}`
  );
export const getDashboardSelfActivityIC = (queryRequest: string) =>
  get(
    `${config.API_URL}/internal-compliance-task/view/dashboard/self-activity?${queryRequest}`
  );
export const getDashboardSelfComplianceUserEntityIC = (queryRequest: string) =>
  get(
    `${config.API_URL}/internal-compliance-task/view/dashboard/overall?${queryRequest}`
  );
export const getDashboardSelfComplianceUserEntityDataIC = (
  queryRequest: string,
  is_list: boolean
) =>
  get(
    `${config.API_URL}/internal-compliance-task/view/dashboard/by-entity?${queryRequest}&is_list=${is_list}`
  );

export const refreshComplainceIC = () =>
  get(`${config.API_URL}/internal-compliance-task/refresh/dashboard`);

// --------------------------------  Configuration   ------------------------------------ //
// -> Internal Compliance -> Fields
export const icAllFields = (queryRequest: string) =>
  get(`${config.API_URL}/form-properties/fields?${queryRequest}`);

export const getSpecificField = (id: string) =>
  get(`${config.API_URL}/form-properties/${id}`);

export const updateSpecificField = (id: string, payload: object) =>
  patch(`${config.API_URL}/form-properties/${id}`, payload);

export const updateFieldsSwap = (payload: object) =>
  patch(`${config.API_URL}/form-properties/seq-no/swap`, payload);

export const getDeletedFields = (queryRequest: string) =>
  get(`${config.API_URL}/form-properties/deleted/fields?${queryRequest}`);

export const restoreDeletedFields = (id: string) =>
  get(`${config.API_URL}/form-properties/restore/field/${id}`);

export const removeFormField = (id: string) =>
  Delete(`${config.API_URL}/form-properties/fields/${id}`);

export const getCustomDatatypes = (queryRequest: string) =>
  get(`${config.API_URL}/form-properties/list/data-type?${queryRequest}`);

export const createCustomField = (payload: object) =>
  post(`${config.API_URL}/form-properties/custom-fields`, payload);

export const updateCustomField = (id: string, payload: object) =>
  post(`${config.API_URL}/form-properties/custom-fields/${id}`, payload);

export const removeCustomField = (id: string) =>
  Delete(`${config.API_URL}/form-properties/fields/${id}`);

export const updateCustomFields = (payload: object) =>
  patch(`${config.API_URL}/form-properties/fields`, payload);

// -> Internal Compliance -> Field List

export const adminListManagementCreateGroupIC = (payload: object) =>
  post(`${config.API_URL}/ic-list-management/groups`, payload);

export const adminListManagementGetGroupsIC = () =>
  get(`${config.API_URL}/ic-list-management/groups`);

export const adminListManagementPatchGroupIC = (id: string, payload: object) =>
  patch(`${config.API_URL}/ic-list-management/groups/${id}`, payload);

export const adminListManagementDeleteGroupIC = (id: string) =>
  Delete(`${config.API_URL}/ic-list-management/groups/${id}`);

export const adminListManagementCreateGroupItemsIC = (
  groupId: string,
  payload: object
) =>
  post(`${config.API_URL}/ic-list-management/groups/${groupId}/items`, payload);

export const adminListManagementGetGroupsItemsIC = (groupId: string) =>
  get(`${config.API_URL}/ic-list-management/groups/${groupId}/items`);

export const adminListManagementPatchGroupItemsIC = (
  groupId: string,
  itemId: string,
  payload: object
) =>
  patch(
    `${config.API_URL}/ic-list-management/groups/${groupId}/items/${itemId}`,
    payload
  );

export const adminListManagementDeleteGroupItemsIC = (
  groupId: string,
  itemId: string
) =>
  Delete(
    `${config.API_URL}/ic-list-management/groups/${groupId}/items/${itemId}`
  );
export const getSmartFilterListManagementListIC = (queryRequest: string) =>
  get(`${config.API_URL}/ic-list-management/list-item?${queryRequest}`);

// -> Internal Compliance -> Internal Mapping

export const deleteSpecificChildEntityGroupIC = (id: string) =>
  Delete(`${config.API_URL}/ic-entity-mapping/${id}`);

export const deleteSpecificEntityGroupIC = (id: string) =>
  Delete(`${config.API_URL}/ic-entity-mapping/group/${id}`);

export const getChildEntityGroupsIC = (queryRequest: string) =>
  get(`${config.API_URL}/ic-entity-mapping?${queryRequest}`);

export const getEntityGroupsIC = (queryRequest: string) =>
  get(`${config.API_URL}/ic-entity-mapping/group?${queryRequest}`);

export const updateChildEntityGroupStatusIC = (payload: object) =>
  patch(`${config.API_URL}/ic-entity-mapping/bulk/active-inactive`, payload);

export const bulkUpdateSelfComplianceTaskIC = (payload: object) =>
  patch(
    `${config.API_URL}/internal-compliance-task/bulk/active-inactive`,
    payload
  );

export const createEntityGroupIC = (payload: object) =>
  post(`${config.API_URL}/ic-entity-mapping/group`, payload);

export const updateChildEntityGroupIC = (id: string, payload: object) =>
  patch(`${config.API_URL}/ic-entity-mapping/${id}`, payload);

export const createChildEntityGroupIC = (payload: object) =>
  post(`${config.API_URL}/ic-entity-mapping`, payload);

// ------------------------------------ Repositry  ------------------------------------ //
//  ->  Internal Mapping

export const UpdateSelfComplianceTaskIC = (id: string, payload: object) =>
  patch(`${config.API_URL}/internal-compliance-task/${id}`, payload);

export const UpdateMultipleSelfComplianceTaskIC = (payload: object) =>
  patch(`${config.API_URL}/internal-compliance-task/bulk/update`, payload);

export const getSelfComplianceTaskListIC = (queryRequest: string) =>
  get(`${config.API_URL}/internal-compliance-task?${queryRequest}`);

export const updateSelfComplianceListStatusIC = (payload: object) =>
  patch(`${config.API_URL}/internal-compliance/bulk/change-status`, payload);

export const updateSelfComplianceListUserIC = (payload: object) =>
  patch(`${config.API_URL}/internal-compliance-task/bulk/change-user`, payload);

// -> Internal Compliance

export const adminGetCheckpointIC = (queryRequest: string) =>
  get(`${config.API_URL}/ic-checkpoint?${queryRequest}`);

export const adminCreateCheckpointIC = (payload: object) =>
  post(`${config.API_URL}/ic-checkpoint`, payload);

export const adminDeleteSpecificCheckpointIC = (id: string) =>
  Delete(`${config.API_URL}/ic-checkpoint/${id}`);

export const getSelfComplianceListIC = (queryRequest: string) =>
  get(`${config.API_URL}/internal-compliance?${queryRequest}`);

export const getActivityMyTaskCalenderInfoIC = (queryRequest: string) =>
  get(
    `${config.API_URL}/internal-compliance-task/view/calendar-view?${queryRequest}`
  );

export const getSpecificSelfComplianceTaskIC = (id: string) =>
  get(`${config.API_URL}/internal-compliance-task/${id}`);

export const configureSelfComplianceIC = (payload: object) =>
  post(`${config.API_URL}/internal-compliance/configure`, payload);

export const getSpecificSelfComplianceListIC = (id: string) =>
  get(`${config.API_URL}/internal-compliance/${id}`);

export const getSpecificSelfComplianceTaskHistoryIC = (
  id: string,
  queryRequest: string
) =>
  get(
    `${config.API_URL}/internal-compliance-task/${id}/task-history?${queryRequest}`
  );
// ------------------------------------ User Entity Mapping ------------------------------------ //

//user entity mapping

export const getUserEntityGroupsIC = (queryRequest: string) =>
  get(`${config.API_URL}/user-ic-entity-permissions/groups?${queryRequest}`);

export const getUserEntityGroupsItemsIC = (queryRequest: string) =>
  get(
    `${config.API_URL}/user-ic-entity-permissions/groups/items?${queryRequest}`
  );

export const getUserChildEntitiesIC = (queryRequest: string) =>
  get(`${config.API_URL}/user-ic-entity-permissions?${queryRequest}`);

export const getSpecificUserChildEntitiesIC = (id: string) =>
  get(`${config.API_URL}/user-ic-entity-permissions/${id}`);

export const addUserChildEntityIC = (payload: object) =>
  post(`${config.API_URL}/user-ic-entity-permissions`, payload);

export const updateUserChildEntityIC = (id: string, payload: object) =>
  patch(`${config.API_URL}/user-ic-entity-permissions/${id}`, payload);

export const deleteUserChildEntityIC = (id: string) =>
  Delete(`${config.API_URL}/user-ic-entity-permissions/${id}`);

// ------------------------------------ Export  ------------------------------------ //

export const downloadSelfComplianceReportsIC = (payload: string) =>
  post(`${config.API_URL}/reports/internal-compliance`, payload);

export const exportCheckpointMasterIC = (payload: object) =>
  post(`${config.API_URL}/reports/export-ic-checkpoint-master`, payload);

export const downloadSelfComplianceIC = (queryRequest: string) =>
  get(`${config.API_URL}/internal-compliance/export/data?${queryRequest}`);

// ------------------------------------ Import  ------------------------------------ //

export const importSelfComplianceIC = (payload: object) =>
  postFileUpload(`${config.API_URL}/internal-compliance/import/data`, payload);

export const importCheckpointIC = (payload: object) =>
  postFileUpload(`${config.API_URL}/ic-checkpoint/import`, payload);

export const importEntityMappingIC = (payload: object) =>
  postFileUpload(`${config.API_URL}/ic-entity-mapping/import/data`, payload);

export const importCheckpointConfigIC = (payload: object) =>
  postFileUpload(`${config.API_URL}/internal-compliance/import/data`, payload);

export const getICChildEntityGroupsIC = (queryRequest: string) =>
  get(`${config.API_URL}/internal-compliance-task/filters/entity-mapping?${queryRequest}`);